module.exports = __webpack_public_path__ + "80b4b8a45f67f46443880b60f0c4cf92.jpg";